/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { jsx } from 'theme-ui';
import { initializeApp } from 'firebase/app';
import React from 'react';
import firebaseConfig from './firebaseConfig';

initializeApp(firebaseConfig);

export default function wrapRootElement({ element }) {
  return <RootFirebaseAppProvider>{element}</RootFirebaseAppProvider>;
}

// This Provider is modeled after reactfire - although it's not possible to use it currently (SSR issues), the API is good.
function RootFirebaseAppProvider({ children /* , firebaseConfig */ }) {
  return <>{children}</>;
}
